module.exports = "https://static.wmbcdn.com/uniweb/images/d8d8e8300a7c5800dacb48e4c8ef8ee2.svg";